<template>
  <div class="animated">
    <modal-trash-basket
      v-if="show_modal"
      :entity_type="entity_type"
      :trash="trash"
      repository_type="crm"
      @onUpdate="onUpdate"
    />

    <v-server-table
      :columns="table_config.columns"
      :options="table_config.options"
      :theme="theme"
      :ref="ref"
      id="customer-server-table"
      class="w-100"
    >
      <span slot="created_at" slot-scope="{ row }" v-if="row && row.created_at">
        {{ row.created_at | moment("L") }}
      </span>

      <span slot="actions" slot-scope="{ row }">
        <b-button v-if="checkPermission('edit customer grower')" :to="`/customer/${customer_id}/growers/${row.id}/edit`" variant="warning" class="px-1 py-0 text-white mr-1">
          <i class="fa fa-pencil" />
        </b-button>

        <template v-if="checkPermission('delete customer grower')">
          <a
            v-if="isDeleted(row.id)"
            class="btn btn-success px-1 py-0 text-white mr-1"
            @click="restoreFromTrash(row.id)"
          >
            <i class="fa fa-refresh" />
          </a>
          <a
            v-else
            class="btn btn-danger px-1 py-0 text-white mr-1"
            @click="putToTrash(row)"
          >
            <i class="fa fa-trash" />
          </a>
        </template>
      </span>
    </v-server-table>
  </div>
</template>

<script>
import Vue from "vue"
import { ServerTable } from "vue-tables-2"
import BaseServerTable from "@/components/shared/BaseServerTable"
import CustomerGrowerCollection from "@/collections/crm/CustomerGrowerCollection"
import { AccessControlCheck } from '@/auth/AccessControlCheck'
import ModalTrashBasket from "@/components/shared/ModalTrashBasket"
import { mapActions, mapGetters } from 'vuex'

Vue.use(ServerTable)

export default {
  name: "CustomerGrowerServerTable",
  extends: BaseServerTable,
  components: {
    ServerTable,
    ModalTrashBasket
  },
  props: {
    collection: {
      type: Object,
      default: () => new CustomerGrowerCollection()
    },
    show_columns: {
      type: Array,
      default: () => [
        "name",
        "created_at",
        "actions"
      ]
    },
    filterable: {
      type: Array,
      default: () => [
        "name"
      ],
    },
    sortable: {
      type: Array,
      default: () => [
        "name",
      ],
    },
    customer_id: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      entity_type: "customerGrowers",
      table_config: this.lodash.merge(this.getDefaultTableConfig(), {
        options: {
          headings: {
            name: "Name",
            created_at: "Created At",
          },
        },
      }),
    }
  },
  computed: {
    ...mapGetters({
      trash: "customerGrowersTrash",
    }),
    show_modal() {
      return (
        this.checkPermission("delete customer grower") &&
        this.show_columns.includes("actions")
      );
    },
  },
  methods: {
    ...mapActions(["PUT_TO_TRASH", "RESTORE_FROM_TRASH"]),

    prepareCollectionFilter(filter) {
      if (this.customer_id) {
        filter.filterEquals("customer.id", this.customer_id);
      }

      return filter;
    },

    checkPermission (permission) {
      return AccessControlCheck.checkPermission(permission)
    },

    isDeleted(id) {
      return this.trash.find((item) => item.id === id);
    },
    putToTrash(value) {
      this.PUT_TO_TRASH({ value, name: this.entity_type });
    },
    restoreFromTrash(id) {
      this.RESTORE_FROM_TRASH({ id, name: this.entity_type });
    },
    onUpdate() {
      this.$refs[this.ref].refresh();
    }
  }
}
</script>
